











































































































































import { Message } from "element-ui";
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { RegService } from "@common/service/base-service/reg";
import { PartnerService } from "../service";
import ReadTo from "@/zh-website/src/views/partner/supplier/ReadTo.vue";
import { HomeService } from "@/zh-website/src/views/Homes/service";
@Component({
  components: {
    ReadTo
  }
})
export default class Industry extends Vue {
  isCheck = false;
  dialogFormVisible = false;
  rulecodes="";
  codeImg = "";
  form = {
    field1: "", //推荐人姓名
    field2: "", //推荐人邮箱
    field3: "", //推荐专家名称
    field4: "", //所在公司
    field5: "", //专家职务
    field6: "", //专家电话
    content1: "", //专家简介
    isShow: "1" ,//推荐类型:实名(1)、匿名(0)
    rulecode:""
  };
  created() {
    //
  }
  mounted() {
    this.getCode();
  }
  getCode() {
    HomeService.getCode().then(res => {
      this.codeImg = `data:image/png;base64,${res.data.code}`;
      this.rulecodes = res.data.codeNum;
    });
  }
  //跳转成为专家
  bepro() {
    this.$router.push("/partner/industry/apply");
  }

  //显示推荐专家弹窗
  bshow() {
    this.dialogFormVisible = true;
  }
   //改变验证码
   changeCode() {
    this.getCode();
  }
  //验证邮箱
  emailVerification() {
    const regEmail = RegService.EMAIL;
    if (this.form.field2 != "" && !regEmail.test(this.form.field2)) {
      this.$message.error("邮箱格式不正确");
      this.form.field2 = "";
    } else {
      //
    }
  }
  //验证手机
  phoneVerification() {
    const reg = RegService.PHONE;
    const that = this;
    if (
      that.form.field6 == "" ||
      that.form.field6.length <= 10 ||
      !reg.test(that.form.field6)
    ) {
      that.$message.error("手机号码错误");
      that.form.field6 = "";
      return false;
    } else {
      return true;
    }
  }
  //推荐专家-提交
  onSubmit(formName) {
    if (!this.isCheck) {
      this.$message.error("请仔细阅读并同意隐私协议");
      return;
    }
    const formData = this.form;
    // console.log(formData);
    if (
      formData.field1 != "" &&
      formData.field2 != "" &&
      formData.field3 != "" &&
      formData.field4 != "" &&
      formData.field5 != "" &&
      formData.field6 != "" &&
      formData.content1 != ""&&
      formData.rulecode!=""
    ) {
      const data = {
        name: formData.field1,
        email: formData.field2,
        recommendedName: formData.field3,
        recommendCompanyName: formData.field4,
        recommendJob: formData.field5,
        recommendPhone: formData.field6,
        recommendIntro: formData.content1,
        code:formData.rulecode,
        codeNum:this.rulecodes,
        signStatus:this.isCheck
      };
      PartnerService.addCooperationExpertRecommend(data).then((res: any) => {
        //
        if (res.data) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
        this.dialogFormVisible = false;
        this.form.field1 = "";
        this.form.field2 = "";
        this.form.field3 = "";
        this.form.field4 = "";
        this.form.field5 = "";
        this.form.field6 = "";
        this.form.content1 = "";
        this.form.rulecode="";
        this.getCode();
      });
    } else {
      this.$message.error("请输入信息");
      return false;
    }
  }
}
